import axiosHelper from './axiosApi.js'
const api = {}
const errorHandler = error => {
  return Promise.reject(error)
}
// const post = (url, params) => instance.post(url, Object.assign({ Authorization: store.state.userToken }, params)).catch(errorHandler)
// const post = (url, headers, params) => axiosHelper.getInstance().post(url, headers, params).catch(errorHandler)
const post = (url, params) => axiosHelper.getInstance().post(url, params).catch(errorHandler)
const get = (url, config) => axiosHelper.getInstance().get(url, config).catch(errorHandler)
const deleteItem = (url, config) => axiosHelper.getInstance().delete(url, config).catch(errorHandler)

api.post = post
api.get = get
/* **axios封装post的方法** */
api.loginSystem = (appName, imei, userName, password) => post('/app/auth/login', { headers: { App: appName }, imei, userName, password })
api.loginSystem = (imei, userName, password) => post('/app/auth/login', { imei, userName, password })
api.loginSystemAdmin = (Vcode, UserName, Password) => post('/admin/auth/login', { Vcode, UserName, Password })
api.login = (params) => post('/api/user/login', params)
api.projectList = (phone, token) => post('/api/project/list', {headers: {Authorization: token, 'Content-Type': 'application/json'}, phone})
api.addProduct = (item) => post('/api/commodity', item)
api.updateArticle = (updateType, textScore, text) => post('/api/article/update', {update_type: updateType, text_score: textScore, text})
api.checkSelfBase = (checkType, text) => post('/api/user/examine_from_ai', {check_type: checkType, text})
api.mallLogin = () => post('/api/user/mall_login', {})
api.mallRegister = () => post('/api/user/mall_register', {})
api.contentFromAi = (params) => post('/api/user/content_from_ai', params)
api.getQrStatus = (params) => post('/api/login_qr_code_status', params)

/* *************************************get方法******************************* */
api.getVersion = (appName) => get('/app/deviceApp/versions', { headers: { App: appName } }) // 获取app历史列表
api.getDepartmentInfo = (tokenString, departmentId) => get('/admin/department/getInfo', { headers: { DataDepartmentId: departmentId } }) // 根据路由传递的部门id和token获取部门信息 Authorization: tokenString,
api.getUser = (pageNo, pageSize, sortField, sortOrder) => get('/admin/userInfo/getTable', {pageNo, pageSize, sortField, sortOrder})
api.getDeviceInfo = (pageNo, pageSize, sortField, sortOrder) => get('/admin/devicePhone/getTable', {pageNo, pageSize, sortField, sortOrder})
api.getProductList = (phone, projectId) => get(`/api/commodity/commodity_list?phone=${phone}&project_id=${projectId}`)
api.getArticle = (projectId) => get(`/api/article/list?project_id=${projectId}`)
api.getArticle2 = (projectId) => get(`/api/article/info`)
api.getAesKey = () => get(`/api/user/get_aes_key`)
api.getUserInfo = () => get('/api/user/info', {start: 0, limit: 10})
api.getLoginQrCode = (params) => get('/api/get_login_qr_code', {params})

api.deleteProduct = (id) => deleteItem(`/api/commodity?id=${id}`)
export default api



// WEBPACK FOOTER //
// ./src/customJs/api.js